<script>
    /*
    	MoreInfoButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiInformationOutline } from '@mdi/js';

    export let onClick;

    onMount(() => {
    })

</script>

<style>

    .more-info-button {
        color: var(--tcui-primary);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: .5px;
        /* border: 1px solid red; */
    }

    .more-info-button:hover {
        cursor: pointer;
        color: var(--tcui-secondary);
    }

    .more-info-button .button-content {
        display: flex;
        align-items: center;
    }

    .more-info-button .button-text {
        text-align: right;
    }

    :global(.more-info-button .button-content svg) {
        width: 22px;
        height: 22px;
        margin-left: 2px;
        fill: var(--tcui-primary);
        outline: none;
    }

    :global(.more-info-button .button-content:hover svg) {
        fill: var(--tcui-secondary);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="more-info-button" on:click={onClick} >
    <div class="button-content">
        <div class="button-text">More Info</div>
        <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiInformationOutline} /></Icon>
    </div>
</div>
